var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isChannelVisible)?_c('div',{ref:"element",class:[
		'channel-list-item',
		{active: _vm.active},
		{'parted-channel': _vm.channel.type === 'channel' && _vm.channel.state === 0},
		{'has-draft': _vm.channel.pendingMessage},
		{
			'not-secure':
				_vm.channel.type === 'lobby' && _vm.network.status.connected && !_vm.network.status.secure,
		},
		{'not-connected': _vm.channel.type === 'lobby' && !_vm.network.status.connected} ],style:(_vm.channel.closed ? {transition: 'none', opacity: 0.4} : null),attrs:{"aria-label":_vm.getAriaLabel(),"title":_vm.getAriaLabel(),"data-name":_vm.channel.name,"data-type":_vm.channel.type,"aria-controls":'#chan-' + _vm.channel.id,"aria-selected":_vm.active,"role":"tab"},on:{"click":_vm.click,"contextmenu":function($event){$event.preventDefault();return _vm.openContextMenu($event)}}},[_vm._t("default",null,{"network":_vm.network,"channel":_vm.channel,"activeChannel":_vm.activeChannel})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }